module.exports = __webpack_public_path__ + "assets/vehicle-locked.7050b609.svg";